export var fontFamilies = {
  inter: '"Inter", -apple-system, BlinkMacSystemFont, Segoe UI, "Roboto", Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
  riforma: '"Riforma", -apple-system, BlinkMacSystemFont, Segoe UI, "Roboto", Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol'
};
export var fontWeights = {
  riforma: {
    default: 400,
    medium: 500,
    bold: 600
  },
  inter: {
    default: 400,
    bold: 600
  },
  // Legacy
  normal: 400,
  bold: 600
};
export var fonts = {
  display96: {
    fontSize: '96px',
    lineHeight: 7 / 6,
    fontFamily: 'riforma',
    defaultEl: 'h1'
  },
  display72: {
    fontSize: '72px',
    lineHeight: 10 / 9,
    fontFamily: 'riforma',
    defaultEl: 'h2'
  },
  display60: {
    fontSize: '60px',
    lineHeight: 6 / 5,
    fontFamily: 'riforma',
    defaultEl: 'h3'
  },
  display52: {
    fontSize: '52px',
    lineHeight: 16 / 13,
    fontFamily: 'riforma',
    defaultEl: 'h3'
  },
  display44: {
    fontSize: '44px',
    lineHeight: 14 / 11,
    fontFamily: 'riforma',
    defaultEl: 'h4'
  },
  title36: {
    fontFamily: 'riforma',
    fontSize: '36px',
    lineHeight: 1.22,
    defaultEl: 'h2'
  },
  title32: {
    fontFamily: 'riforma',
    fontSize: '32px',
    lineHeight: 1.25,
    defaultEl: 'h2'
  },
  title28: {
    fontFamily: 'riforma',
    fontSize: '28px',
    lineHeight: 9 / 7,
    defaultEl: 'h3'
  },
  title24: {
    fontFamily: 'riforma',
    fontSize: '24px',
    lineHeight: 4 / 3,
    defaultEl: 'h4'
  },
  title20: {
    fontFamily: 'riforma',
    fontSize: '20px',
    lineHeight: 1.2,
    defaultEl: 'h5'
  },
  label18: {
    fontFamily: 'riforma',
    fontSize: '18px',
    lineHeight: 14 / 9
  },
  label16: {
    fontFamily: 'riforma',
    fontSize: '16px',
    lineHeight: 1.5
  },
  label14: {
    fontFamily: 'riforma',
    fontSize: '14px',
    lineHeight: 10 / 7
  },
  label12: {
    fontFamily: 'riforma',
    fontSize: '12px',
    lineHeight: 4 / 3
  },
  body18: {
    fontFamily: 'inter',
    fontSize: '18px',
    lineHeight: 14 / 9
  },
  body16: {
    fontFamily: 'inter',
    fontSize: '16px',
    lineHeight: 1.5
  },
  body14: {
    fontFamily: 'inter',
    fontSize: '14px',
    lineHeight: 10 / 7
  },
  body12: {
    fontFamily: 'inter',
    fontSize: '12px',
    lineHeight: 3 / 2
  },
  // legacy
  1: {
    fontSize: '52px',
    lineHeight: '64px'
  },
  2: {
    fontSize: '36px',
    lineHeight: '44px'
  },
  3: {
    fontSize: '24px',
    lineHeight: '32px'
  },
  4: {
    fontSize: '20px',
    lineHeight: '24px'
  },
  5: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  6: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  body: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  small: {
    fontSize: '14px',
    lineHeight: '20px'
  },
  caption: {
    fontSize: '12px',
    lineHeight: '16px'
  }
};